import React from "react"
import FieldView from "../../../render/view";
import {FieldFormElementProps} from "../../../render/form-elemnent";


export default function FieldReadOnly_FormElement(props: FieldFormElementProps) {

    const value = props.form.getValue(props.field.fieldId)

    const model : any = {}
    model[props.field.fieldId] = value

    return <FieldView field={props.field} model={model} />
}
